import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { Feedback, useDraggable } from "@skilitics/drag-drop";

import type { Point } from "../types";

const PerspectiveDraggableContainer = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  touch-action: none;
`;

export type DraggableProps = {
  id: number | string;
  position: Point;
  dragDelta?: Point;
  disabled?: boolean;
  children: ReactNode;
};

export const PerspectiveDraggable = ({ id, position, dragDelta, children, disabled = false }: DraggableProps) => {
  // feedback: "none" is required because PerspectiveDraggable is a full-size canvas
  // container. The default Feedback plugin would set position:fixed and rip it out of
  // its parent, covering the entire screen and bouncing on drop.
  const { ref } = useDraggable({ id: `${id}`, disabled, plugins: [Feedback.configure({ feedback: "none" })] });

  const x = Math.round(position.x + (dragDelta?.x ?? 0));
  const y = Math.round(position.y + (dragDelta?.y ?? 0));

  const style = {
    transform: `translate3d(${x}px, ${y}px, 0)`,
  };

  return (
    <PerspectiveDraggableContainer ref={ref} id={`draggable-${id}`} style={style}>
      {children}
    </PerspectiveDraggableContainer>
  );
};
